import { FunctionComponent, MutableRefObject } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
} from "@mui/material";

import { SubCategoryMap } from "../../utils/options";
import { OptionSelect } from "../OptionSelect";
import { OptionListItem } from "./ProductOption";

export const POItemBox: FunctionComponent<{
  category: NonNullable<OptionListItem["SubCategory"]>["Category"];
  items: OptionListItem[];
  catmap: SubCategoryMap;
  productConfiguration: string;
  readonly?: boolean;
  originalItems?: MutableRefObject<Record<string, { options: string[]; variableType: string; number: number; text: string; unit: string }>>;
  setShowRemove: (id: string | boolean) => void;
  onBeforeChange?: () => void;
}> = ({
  category,
  items,
  catmap,
  productConfiguration,
  readonly,
  originalItems,
  setShowRemove,
  onBeforeChange,
}) => {
  if (!category) return null;

  return (
    <Card
      sx={{
        width: "100%",
        margin: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader title={category.name}></CardHeader>
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {items.map((ol, index) => {
          return (
            <Box
              sx={{ width: "100%", marginBottom: 1 }}
              key={`${category._id}-${ol.SubCategory?._id ?? (ol as { subcategory?: string }).subcategory}-${index}`}
            >
              <OptionSelect
                readonly={readonly}
                productId={productConfiguration}
                catmap={catmap}
                optionList={ol}
                originalItems={originalItems}
                onBeforeChange={onBeforeChange}
              />
            </Box>
          );
        })}
      </CardContent>
      <Box sx={{ flexGrow: 1 }}></Box>
      <CardActions>
        {!readonly && (
          <Button
            sx={{ marginLeft: "auto" }}
            onClick={() => {
              setShowRemove(category._id);
            }}
          >
            Remove
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
